module.exports = __webpack_public_path__ + "static/media/arrow-up.5fbb1e65.svg";